// @flow

export const computeIs250kWarrantyOnly = ({
  type,
  protect,
}: {
  type: ?string,
  protect: ?string,
}): boolean => {
  const isProWildCardCert = type === 'pro' && protect === 'wildcard';

  const isBusCert = type === 'business';

  /**
   * true if only the 250k warranty is available according to
   * selected options.
   */
  return isProWildCardCert || isBusCert;
};
